<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" sm="12">
        <div class="d-flex">
          <v-icon class="text-center pr-2">mdi-calendar-clock</v-icon>
          <VueCtkDateTimePicker
            id="StartTimePicker"
            label="StartTime"
            v-model="start_date"
            prepend-icon="mdi-image-edit"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            minuteInterval="5"
            class="pr-2"
          />
          <VueCtkDateTimePicker
            id="EndTimePicker"
            label="EndTime"
            v-model="end_date"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            minuteInterval="5"
            right
          />
          <div class="d-flex">
            <h5 class="ml-auto caption font-weight-light pl-2">
              timezone: {{ timezone }}
            </h5>
          </div>
          <v-btn color="channel" dark class="ml-2" @click="apply">Apply</v-btn>
        </div>
      </v-col>
      <v-col cols="12" sm="12">
        <VisitInfoContent :visitInfo="visitInfo"></VisitInfoContent>
      </v-col>
      <v-col cols="12" sm="12" class="pt-0">
        <UserStats :usersData="usersData"></UserStats>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "ContentStatic",
  props: ["id"],
  data: () => ({
    page: {
      title: "Static"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Static",
        disabled: true
      }
    ],
    total: 0,
    browserRate: null,
    deviceRate: null,
    countryData: null,
    visitInfo: null,
    usersData: null,
    start_date: "",
    end_date: ""
  }),
  async created() {
    await this.getContentChartData();
  },
  mounted() {
    this.start_date = moment().subtract(1, "months");
    this.end_date = moment();
    console.log(this.start_date, this.end_date, this.start, this.end);
  },
  methods: {
    async apply() {
      console.log(this.start, this.end);
      await this.getContentChartData(this.start, this.end);
    },
    async getContentChartData(startTime, endTime) {
      const channel_id = this.$store.state.channelId;
      const content_id = this.id;
      const start = startTime ? startTime : 0;
      const end = endTime ? endTime : Math.floor(Date.now() / 1000 + 600);

      const path = `/admin/getContentChartData?channel_id=${channel_id}&content_id=${content_id}&start=${start}&end=${end}`;
      try {
        const data = await this.$axiosAuth.get(path);
        if (data && data.status == 200) {
          const result = data.data;
          this.browserRate = result.browserRate;
          this.deviceRate = result.deviceRate;
          this.countryData = result.countryData;
          this.total = result.visitorsCount;
          this.visitInfo = {};
          this.visitInfo.netVisitorsCount = result.netVisitorsCount;
          this.visitInfo.visitorsCount = result.visitorsCount;
          this.visitInfo.spentTime = result.spentTime;
          this.visitInfo.averageSpentTime = result.averageSpentTime;
          this.usersData = result.usersData;
          console.log({ result });
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  components: {
    VisitInfoContent: () =>
      import("@/views/dashboards/dashboardComponents/VisitInfoContent"),
    UserStats: () => import("@/views/dashboards/dashboardComponents/UserStats")
  },
  computed: {
    timezone: function() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    start: function() {
      return moment(this.start_date).unix();
    },
    end: function() {
      return moment(this.end_date).unix();
    }
  }
};
</script>
